// components/ProductList.js

import React from "react";
import ProductItem from "../ProductItem";
import "./index.scss";
import Lottie from "react-lottie";
import { defaultOptionsEmpty } from "../../assets/lottie-animations/animationOptions";
function ProductList({ listProducts, type }: any) {
  return (
    <section className="product-list">
      {listProducts?.length > 0 ? (
        listProducts.map((product: any, index: any) => (
          <ProductItem key={index} product={product} type={type} />
        ))
      ) : (
        <div className="empty-products">
  <div className="empty-illustration">
    <Lottie options={defaultOptionsEmpty} height={180} width={180} />
  </div>

  <h2 className="empty-title">Aucun produit trouvé</h2>

  <p className="empty-description">
    Il n’y a actuellement aucun produit à afficher dans cette section.
  </p>

  <button
    className="empty-action"
    onClick={() => window.location.reload()}
  >
    Actualiser la page
  </button>
</div>

      )}
    </section>
  );
}


export default ProductList;
